export default {
  title: 'AI-suggesties',
  subtitle: 'Suggesties van de FoodAmigos-agent voor uw restaurants.',
  empty: 'Niets te tonen hier.',
  tabs: {
    pending: 'In behandeling',
    history: 'Geschiedenis',
  },
  table: {
    id: 'ID',
    company: 'Restaurant',
    type: 'Type',
    summary: 'Suggestie',
    created_at: 'Aangemaakt',
    status: 'Status',
    actions: 'Acties',
  },
  statuses: {
    pending: 'In behandeling',
    confirmed: 'Bevestigd',
    applied: 'Toegepast',
    rejected: 'Afgewezen',
    failed: 'Mislukt',
    expired: 'Verlopen',
  },
  types: {
    'smart_pricing.global_reduce': 'Korting op volledig menu',
    'smart_pricing.category_reduce': 'Categoriekorting',
    'competitor_listing.confirm': 'Marketplace-vermelding bevestigen',
    'catalog.price_correct': 'Prijscorrectie',
    'catalog.add_item': 'Ontbrekend item toevoegen',
    'catalog.quality': 'Contentkwaliteit',
    'catalog.reorder': 'Menu herordenen',
  },
  actions: {
    review: 'Beoordelen',
    confirm: 'Bevestigen',
    reject: 'Afwijzen',
    cancel: 'Annuleren',
    edit: 'Bewerken',
  },
  edit: {
    label: 'Beschrijf de gewenste wijziging (er wordt een nieuwe revisie gegenereerd)',
    placeholder: 'Beschrijf de gewenste wijziging',
    placeholders: {
      'smart_pricing.global_reduce':
        'bijv. maak het 15%, hernoem het naar „Zomer -15%", of pas het alleen toe op bezorging',
      'smart_pricing.category_reduce': 'bijv. stel de Drankenkorting in op 10% en verwijder afhalen',
      'catalog.price_correct': 'bijv. verwijder de „Cola"-correctie, of stel „Pizza" in op €7,50',
      'catalog.add_item': 'bijv. verwijder het „Water"-item, of prijs „Falafel Wrap" op €6,50',
      'catalog.quality': 'bijv. verwijder de items „Friet" en „Cola" uit de lijst',
      'catalog.reorder': 'bijv. zet Dranken als laatste en verplaats de bestseller naar de top van Bowls',
      'competitor_listing.confirm': 'bijv. vervang de Uber Eats-link door https://…, of voeg Wolt toe: https://…',
    },
    submit: 'Revisie genereren',
  },
  revisions: {
    label: 'Revisie',
    original: 'Origineel',
    revision_n: 'Revisie {{n}}',
  },
  detail: {
    title: 'Suggestiedetail',
    targets: 'Betrokken items',
    evidence: 'Waarom de agent dit suggereert',
    no_targets: 'Geen itemdetails opgegeven.',
    composed_from: 'Samengesteld uit',
    items_suffix: 'items',
    nutrition: 'Voedingswaarden',
    uncategorized: 'Ongecategoriseerd',
    decided_by: 'Beslist door',
    decision_note: 'Notitie',
    category_existing: 'bestaand',
    category_new: 'nieuw',
    product: 'Product',
    price_change: 'Prijswijziging',
    no_items: 'Geen items',
    fills_image: '+ afbeelding',
    fills_description: '+ beschrijving',
    fills_nutrition: '+ voedingswaarden',
    fills_modifiers: '+ opties',
    competitor_links: 'Concurrentielinks',
    no_competitor_links: 'Nog geen opgeloste concurrentielinks.',
  },
  competitors: {
    lieferando: 'Lieferando',
    wolt: 'Wolt',
    deliveroo: 'Deliveroo',
    uber_eats: 'Uber Eats',
  },
  reject_modal: {
    title: 'Deze suggestie afwijzen',
    note_label: 'Reden',
    note_placeholder: 'Leg kort uit waarom u deze suggestie afwijst',
  },
  toasts: {
    load_failed: 'Suggesties laden mislukt',
    confirmed: 'Suggestie bevestigd',
    rejected: 'Suggestie afgewezen',
    action_failed: 'Die actie kon niet worden voltooid',
    revision_created: 'Nieuwe revisie gegenereerd',
    revision_failed: 'Kon geen revisie genereren op basis van die instructie',
    choose_revision: 'Deze suggestie heeft meerdere revisies — open hem en kies er een om te bevestigen',
  },
};
